{
	"ariaApplyPreset": "Apply preset {{name}}",
	"ariaCreateNewPreset": "Create New Preset",
	"ariaImportLrPresets": "Import LR Presets",
	"ariaImportPreset": "Import Preset",
	"ariaPresetGroupMenu": "Preset Group Menu",
	"ariaPresetMenu": "Preset Menu",
	"ariaPresetPanelMenu": "Preset Panel Menu",
	"autoLightingTitle": "Auto lighting & WB is applied on top of your preset",
	"autoLightingMessage": "Lighting and white balance are automatically adjusted when you apply your preset. You can undo this in History or turn this off in Settings.",
	"createPreset": "Create Preset",
	"errorImportingPresets": "Error importing the following preset(s)",
	"export": "Export",
	"importCompanyPreset": "Import {{company}} Preset",
	"importErrorDefault": "Unable to import preset",
	"importErrorUnsupportedTemplate": "Only Develop Presets are supported. Please request conversion.",
	"importLRPresets": "Import LR Presets",
	"moveToGroup": "Move to group",
	"noPresetsImported": "No individual presets imported",
	"openSettings": "Open Settings",
	"panelPresets": "Presets",
	"presetAppliedPixieset": "Applying preset during setup.",
	"presetAppliedSuggested": "Your preset is applied to all the suggested photos",
	"presetAppliedSuggestedMessagePixieset": "Your preset is applied to all suggested photos. This ensures consistency for your references.",
	"presetAppliedSuggestedMessage": "Your preset is now automatically applied to all the suggested photos. You can disable this in Settings.",
	"presetLabel": "Preset: {{name}}",
	"presetLabelNone": "Preset: None",
	"presetMigrateTitle": "{{productName}} is changing how its presets are stored",
	"presetMigrateMessage": "If you have an issue using this preset, please delete it, then reimport it.",
	"remove": "Remove",
	"rename": "Rename",
	"renameGroup": "Rename Group",
	"renamePreset": "Rename Preset",
	"sliderStrength": "Strength",
	"userPresets": "User Presets"
}
